/**
 * The layer of the app's popovers, menus, dialogs, tooltips and autocomplete lists (their theme
 * overrides), above third-party layers such as the chat widget's (1000002). A layer that must
 * draw over these, such as the editor kit's drop line and drag chip, uses `OVERLAY_Z_INDEX + 1`.
 */
export const OVERLAY_Z_INDEX = 2000000001
